
@if (this.ReportType === "AMS" ) {
  <iframe title="AMS"
    style="height: 90vh; display: block; width: -webkit-fill-available"
    src="https://app.powerbi.com/reportEmbed?reportId=6066ee1a-8fc6-4ec4-8bb3-71ca4aa5311c&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
    frameborder="0"
    allowFullScreen="true">
  </iframe>
}

@if (this.ReportType != "EA" && this.ReportType != "AMS"  ) {
  <div>
    <br /><br /><br /><br />
    <h4>Only available EA / AMS reports</h4>
  </div>
}

@if (this.ReportType === "EA" ) {
  <iframe title="EA"
    style="height: 90vh; display: block; width: -webkit-fill-available"
    src="https://app.powerbi.com/reportEmbed?reportId=5ace3355-46ef-4060-87b5-dce61d46b650&autoAuth=true&ctid=84d9a216-e285-4aac-b163-0dfd0c074546"
    frameborder="0"
    allowFullScreen="true">
  </iframe>
}



